// import api from './api';
import { apiUtils } from '../utils/api';


export const getServiceTypesList = async () => {
  return await apiUtils.get('services/');
};

export const createServiceType = async (form) => {
  const payload = {
    type_description: form.type_description,
    time_cost: form.time_cost,
    charge: form.charge
  };
  const response = await apiUtils.post('services/', payload);
  return response.data;
}; 

export const updateServiceType = async (id, data) => {
  const payload = {
    type_description: data.type_description,
    time_cost: data.time_cost,
    charge: data.charge,
  };
  return await apiUtils.put(`services/${id}/`, payload);
};

export const deleteServiceType = async (id) => {
  return await apiUtils.delete(`services/${id}/`);  
};
